































































import {
  defineComponent,
  PropType,
  ref,
  computed,
  useRoute
} from '@nuxtjs/composition-api'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCardTitle from '~/components/shared/configurable/card/CCardTitle.vue'
import CCardHeader from '~/components/shared/configurable/card/CCardHeader.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import LoanCalculator from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculator.vue'
import LoanPerks from '~/components/car/classifieds/view/partials/loans/perks/LoanPerks.vue'
import { useAnalytics } from '~/compositions/analytics'
import { v4 as uuidv4 } from 'uuid'
import TbiInfoModal from '~/components/car/classifieds/view/partials/loans/TbiInfoModal.vue'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { TbiLoanType } from '~/constants/loan/tbi'

export default defineComponent({
  components: {
    TbiInfoModal,
    LoanPerks,
    LoanCalculator,
    CImg,
    CCardTitle,
    CCard,
    CCardHeader
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    })
  },
  props: {
    loanType: {
      type: String as PropType<TbiLoanType>,
      required: false,
      default: TbiLoanType.AUTO
    }
  },
  setup() {
    const analytics = useAnalytics()
    const randomId = uuidv4()
    const showTbiInfoModal = ref(false)
    const route = useRoute()
    const isLandingPage = computed(() =>
      ['__landing_pages_tbi_blackfriday', '__landing_pages_tbi'].includes(
        route.value.name as string
      )
    )
    const onVisible = () => {
      analytics.recordEvent({
        namespace: 'n_classified_view_loans_visible',
        action: 'load',
        label: randomId
      })
    }
    return {
      randomId,
      onVisible,
      showTbiInfoModal,
      isLandingPage
    }
  }
})
